<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" width="88%" top="4vh"
             custom-class="wave-dialog" :append-to-body="true" @close="handleClose">
    <div v-loading="loading" element-loading-text="录波数据加载中...">
      <div ref="chart" style="width:100%; height:64vh;"></div>
    </div>
  </el-dialog>
</template>

<script>
import axios from 'axios'
import * as echarts from 'echarts'

const API_BASE = '/mqtt'

export default {
  name: 'WaveChart',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    record: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      chart: null
    }
  },
  computed: {
    title(){
      return '录波文件 - ' + ((this.record && this.record.fileName) || '')
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val) {
        this.$nextTick(() => this.load())
      }
    }
  },
  beforeDestroy() {
    this.disposeChart()
  },
  methods: {
    disposeChart() {
      if (this.chart) {
        this.chart.dispose()
        this.chart = null
      }
    },
    async load() {
      this.loading = true
      try {
        const res = await axios.get(`${API_BASE}/exportCsv`, {
          params: {
            topic: this.record.topic,
            name: this.record.fileName
          },
          responseType: 'blob'
        })
        const buf = await res.data.arrayBuffer()
        const text = new TextDecoder('gb2312').decode(buf)
        this.render(this.parseCsv(text))
      } catch (error) {
        console.error('加载录波失败:', error)
        this.$message.error('加载录波数据失败')
      } finally {
        this.loading = false
      }
    },
    parseCsv(text) {
      console.info(11111)
      const lines = text.split(/\r?\n/).filter(l => l.trim())
      if (lines.length < 2) {
        return null
      }
      const header = lines[0].split(',').map(s => s.trim())
      const chNames = header.slice(2) // 点号,绝对时标(ms),通道...
      const x = []
      const seriesData = chNames.map(() => [])
      for (let i = 1; i < lines.length; i++) {
        const cols = lines[i].split(',')
        if (cols.length < 3) {
          continue
        }
        const t = parseFloat(cols[1])
        if (isNaN(t)) {
          continue
        }
        x.push(t)
        for (let c = 0; c < chNames.length; c++) {
          const v = parseFloat(cols[2 + c])
          seriesData[c].push([t, isNaN(v) ? null : v])
        }
      }
      return { chNames, seriesData }
    },
    render(parsed) {
      if (!parsed) {
        this.$message.warning('录波数据为空')
        return
      }
      this.disposeChart()
      this.chart = echarts.init(this.$refs.chart)
      this.chart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'cross' }
        },
        toolbox: {
          feature: {
            dataZoom: {},
            restore: {},
            saveAsImage: {}
          }
        },
        legend: {
          type: 'scroll',
          bottom: 0,
          textStyle: { color: '#555', fontSize: 11 }
        },
        grid: { 
          left: 70, 
          right: 40, 
          top: 40, 
          bottom: 70,
          containLabel: true
        },
        xAxis: {
          type: 'value',
          name: 'ms',
          axisLabel: { formatter: v => v.toFixed(1) }
        },
        yAxis: {
          type: 'value',
          name: 'A',
          scale: true
        },
        dataZoom: [
          { type: 'inside' },
          { 
            type: 'slider', 
            height: 18, 
            bottom: 32 
          }
        ],
        series: parsed.chNames.map((name, i) => ({
          animation: false,
          name: name,
          type: 'line',
          showSymbol: false,
          sampling: 'lttb',
          large: true,
          progressive: 3000,
          progressiveChunkMode: 'mod',
          smooth: false,
          data: parsed.seriesData[i]
        }))
      })
      window.addEventListener('resize', this.resizeChart)
    },
    resizeChart() {
      if (this.chart) {
        this.chart.resize()
      }
    },
    handleClose() {
      window.removeEventListener('resize', this.resizeChart)
      this.disposeChart()
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style>
.wave-dialog .el-dialog__body {
  padding: 10px 16px;
}
</style>
